import styled, { css } from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'

export const Wrapper = styled.div`
  max-width: 900px;
  margin: 15px auto 0;
  padding: 20px 0;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    padding: 20px 15px;
  };

  @media (max-width: ${phoneMaxWidth}px) {
    padding: 0 15px;
  };
`

const titleStyle = props => {
  switch (props.type) {
    case 'main':
      return css`
        color: ${colors.darkPurple};
        margin: 20px 0 30px;
        justify-content: center;
      `
    case 'sub':
      return css`
        color: ${colors.pink};
        margin: 0;
        text-align: left;
      `
    default:
      return css`
        color: ${colors.pink};
        margin: 0 0 30px;
        justify-content: center;
      `
  }
}

export const Title = styled.h1`
  display: flex;
  font-size: 24px;

  ${titleStyle};
`

export const ImageTextWrapper = styled.div`
  display: flex;
  flex-flow: row;
`

export const AmazonImage = styled.div`
  background-image: url(${ASSETS_PATH}/pages/Dashboard/images/amazon-logo.jpg);
  background-size: contain;
  background-repeat: no-repeat;
  min-width: 400px;
  min-height: 200px;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    min-width: 250px;
    min-height: 125px;
  };

  @media (max-width: ${phoneMaxWidth}px) {
    display: none;
  };
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 60px;

  @media (max-width: ${phoneMaxWidth}px) {
    margin-left: 0;
  };
`

export const Paragraph = styled.p`
  color: ${colors.darkPurple};
  font-size: 14px;
`
